import React, { useState, useEffect } from 'react';
import AestheticProtocolMobile from './aestheticProtocolMobile';
import AestheticProtocolWeb from './aestheticProtocolWeb';
import PropTypes from 'prop-types';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const AestheticProtocolRouter = (props) => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? (
    <AestheticProtocolMobile {...props} />
  ) : (
    <AestheticProtocolWeb {...props} />
  );
};

AestheticProtocolRouter.propTypes = {
  patientId: PropTypes.string,
};

AestheticProtocolRouter.defaultProps = {
  patientId: null,
};

export default AestheticProtocolRouter;
